import { APP_VERSION as e } from "../../../constants.js";
import { processBody as t } from "./process-body.js";
import { processParameters as n } from "./process-parameters.js";
import { processSecuritySchemes as r } from "./process-security-schemes.js";
import { processServerUrl as i } from "./process-server-url.js";
import { getResolvedRef as a } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { isElectron as o } from "@scalar/helpers/general/is-electron";
import { filterGlobalCookie as s, getDefaultHeaders as c, restoreConventionalDefaultHeaderNames as l } from "@scalar/workspace-store/request-example";
//#region src/code-example/helpers/operation-to-har/operation-to-har.ts
var u = ({ includeDefaultHeaders: u = !1, operation: d, contentType: f, method: p, path: m, server: h = null, example: g, securitySchemes: _, globalCookies: v, openapiVersion: y, requestBodyCompositionSelection: b, defaultDisabledParameters: x = !1 }) => {
	let S = l(u ? c({
		method: p,
		operation: d,
		exampleName: g ?? "default",
		hideDisabledHeaders: !0,
		hideOverriddenHeaders: !0,
		options: {
			isElectron: o(),
			appVersion: e
		}
	}) : {}), C = d["x-scalar-disable-parameters"]?.["global-cookies"]?.[g ?? "default"] ?? {}, w = {
		method: p,
		url: i(h, m),
		headers: Object.entries(S).map(([e, t]) => ({
			name: e,
			value: t
		})),
		queryString: [],
		postData: void 0,
		httpVersion: "HTTP/1.1",
		cookies: [],
		headersSize: -1,
		bodySize: -1
	}, T = !1, E = !1;
	if (d.parameters) {
		let { url: e, headers: t, queryString: r, cookies: i, hasCookieStyleEntries: a, hasSerializedQuery: o } = n({
			harRequest: w,
			parameters: d.parameters,
			openapiVersion: y,
			example: g,
			defaultDisabled: x
		}), c = v?.filter((t) => s({
			cookie: t,
			url: e,
			disabledGlobalCookies: C
		}))?.map((e) => ({
			name: e.name,
			value: e.value
		})) ?? [];
		T = a, E = o ?? !1, w.url = e, w.headers = t, w.queryString = r, w.cookies = [...c, ...i];
	}
	let D = a(d.requestBody);
	if (D?.content) {
		let e = t({
			requestBody: D,
			contentType: f,
			example: g,
			openapiVersion: y,
			requestBodyCompositionSelection: b
		});
		if (e && (w.postData = e, w.bodySize = e.text?.length ?? -1, e.mimeType)) {
			let t = w.headers.find((e) => e.name.toLowerCase() === "content-type");
			t && (!t.value || e.mimeType.startsWith("multipart/") && e.mimeType.includes("boundary=") && e.text !== void 0) ? t.value = e.mimeType : t || w.headers.push({
				name: "Content-Type",
				value: e.mimeType
			});
		}
	}
	let O = E || d.parameters?.some((e) => a(e)?.in === "querystring");
	if (_) {
		let { headers: e, queryString: t, cookies: n } = r(_);
		w.headers.push(...e), w.queryString.push(...t), w.cookies.push(...n);
	}
	let k = w.headers.find((e) => e.name.toLowerCase() === "cookie");
	if (T && k && w.cookies.length) {
		let e = w.cookies.map((e) => `${encodeURIComponent(e.name)}=${encodeURIComponent(e.value)}`).join("; ");
		k.value = k.value ? `${k.value}; ${e}` : e, w.cookies = [];
	}
	if (O && w.queryString.length) {
		let e = w.url.indexOf("#"), t = e === -1 ? "" : w.url.slice(e), n = e === -1 ? w.url : w.url.slice(0, e), r = w.queryString.map(({ name: e, value: t }) => `${encodeURIComponent(e)}=${encodeURIComponent(t)}`).join("&");
		w.url = `${n}${n.includes("?") ? "&" : "?"}${r}${t}`, w.queryString = [];
	}
	w.postData?.mimeType === "multipart/form-data" && w.postData.params?.some((e) => e.fileName !== void 0) && (w.headers = w.headers.filter((e) => e.name.toLowerCase() !== "content-type"));
	let A = 0;
	for (let e of w.headers) A += (e.name?.length ?? 0) + 2 + (e.value?.length ?? 0) + 2;
	return w.headersSize = A, w;
};
//#endregion
export { u as operationToHar };

//# sourceMappingURL=operation-to-har.js.map